import { Menu } from '@base-ui/react/menu'
import type { ReactElement, ReactNode } from 'react'
import { cx } from '@/lib/cx'

type TriggerElement = ReactElement<Record<string, unknown>>

export type DropdownItem =
  | {
      label: ReactNode
      onSelect?: () => void
      href?: string
      destructive?: boolean
      icon?: ReactNode
    }
  | 'separator'

type DropdownProps = {
  /** Element that opens the menu, e.g. a kit <Button>; trigger props are merged onto it. */
  trigger: TriggerElement
  items: DropdownItem[]
}

// Brand-styled wrapper over Base UI Menu: keyboard traversal, typeahead and
// dismissal come from the primitive (see Modal.tsx for the kit convention).
export function Dropdown({ trigger, items }: DropdownProps) {
  return (
    <Menu.Root>
      <Menu.Trigger render={trigger} />
      <Menu.Portal>
        <Menu.Positioner sideOffset={6} align="start">
          <Menu.Popup className="menu-popup">
            {items.map((item, i) =>
              item === 'separator' ? (
                <Menu.Separator key={i} className="menu-separator" />
              ) : item.href != null ? (
                <Menu.LinkItem
                  key={i}
                  href={item.href}
                  className={cx('menu-item', item.destructive && 'menu-item--destructive')}
                >
                  {item.icon}
                  {item.label}
                </Menu.LinkItem>
              ) : (
                <Menu.Item
                  key={i}
                  onClick={item.onSelect}
                  className={cx('menu-item', item.destructive && 'menu-item--destructive')}
                >
                  {item.icon}
                  {item.label}
                </Menu.Item>
              ),
            )}
          </Menu.Popup>
        </Menu.Positioner>
      </Menu.Portal>
    </Menu.Root>
  )
}
